/**
 * Please note:
 *
 * Translations are provided as an illustration only and are
 * not guaranteed to be accurate or error-free.
 *
 * They are designed to show developers where to store their
 * chosen phrase or spelling variant in the target language.
 */

export const AG_CHARTS_LOCALE_ES_ES: Record<string, string> = {
    ariaAnnounceChart: 'gráfico, ${seriesCount}[number] series',
    ariaAnnounceFlowProportionLink: 'enlace ${index} de ${count}, de ${from} a ${to}, ${sizeName} ${size}',
    ariaAnnounceFlowProportionNode: 'nodo ${index} de ${count}, ${description}',
    ariaAnnounceGaugeChart: 'gráfico de velocímetro, ${caption}',
    ariaAnnounceHierarchyChart: 'gráfico de jerarquía, ${caption}',
    ariaAnnounceHierarchyDatum: 'nivel ${level}[number], ${count}[number] hijos, ${description}',
    ariaAnnounceHoverDatum: '${datum}',
    ariaDescriptionLegendItem: 'Presiona Espacio o Enter para alternar la visibilidad',
    ariaLabelAddHorizontalLine: 'Añadir línea horizontal',
    ariaLabelAnnotationOptionsToolbar: 'Opciones de anotación',
    ariaLabelAnnotationSettingsDialog: 'Configuración de anotación',
    ariaLabelColorPicker: 'Selector de color',
    ariaLabelFinancialCharts: 'Gráficos financieros',
    ariaLabelLegend: 'Leyenda',
    ariaLabelLegendItem: '${label}, Elemento de la leyenda ${index}[number] de ${count}[number]',
    ariaLabelLegendItemUnknown: 'Elemento desconocido de la leyenda',
    ariaLabelLegendPageNext: 'Siguiente página de leyenda',
    ariaLabelLegendPagePrevious: 'Página anterior de la leyenda',
    ariaLabelLegendPagination: 'Paginación de la leyenda',
    ariaLabelNavigator: 'Navegador',
    ariaLabelNavigatorMaximum: 'Máximo',
    ariaLabelNavigatorMinimum: 'Mínimo',
    ariaLabelNavigatorRange: 'Rango',
    ariaLabelRangesToolbar: 'Rangos',
    ariaLabelSettingsTabBar: 'Configuración',
    ariaLabelZoomToolbar: 'Zoom',
    ariaValuePanRange: '${min}[percent0to2dp] a ${max}[percent0to2dp]',
    contextMenuDownload: 'Descargar',
    contextMenuPanToCursor: 'Desplazar hasta aquí',
    contextMenuToggleOtherSeries: 'Alternar Otras Series',
    contextMenuToggleSeriesVisibility: 'Alternar visibilidad',
    contextMenuZoomToCursor: 'Acercar aquí',
    dialogHeaderChannel: 'Canal',
    dialogHeaderDatePriceRange: 'Fecha y Precio',
    dialogHeaderDateRange: 'Rango de fechas',
    dialogHeaderFibonacciRange: 'Fib Retroceso',
    dialogHeaderLine: 'Línea',
    dialogHeaderPriceRange: 'Rango de precios',
    dialogHeaderText: 'Texto',
    dialogInputAlign: 'Alinear',
    dialogInputColorPicker: 'Color',
    dialogInputColorPickerAltText: 'Color del texto',
    dialogInputExtendAbove: 'Extender por encima',
    dialogInputExtendBelow: 'Extender debajo',
    dialogInputExtendChannelEnd: 'Extender fin del canal',
    dialogInputExtendChannelStart: 'Extender inicio del canal',
    dialogInputExtendLeft: 'Extender hacia la izquierda',
    dialogInputExtendLineEnd: 'Extender el final de la línea',
    dialogInputExtendLineStart: 'Extender inicio de la línea',
    dialogInputExtendRight: 'Extender a la derecha',
    dialogInputFibonacciBands: 'Bandas',
    dialogInputFibonacciBandsAltText: 'Bandas de Fibonacci',
    dialogInputFillColorPicker: 'Rellenar',
    dialogInputFillColorPickerAltText: 'Color de relleno',
    dialogInputFontSize: 'Tamaño',
    dialogInputFontSizeAltText: 'Tamaño de Fuente',
    dialogInputLineStyle: 'Guion',
    dialogInputPosition: 'Posición',
    dialogInputReverse: 'Inverso',
    dialogInputShowFill: 'Mostrar relleno',
    dialogInputStrokeWidth: 'Grosor',
    dialogInputStrokeWidthAltText: 'Grosor de línea',
    iconAltTextAlignCenter: 'Centrar',
    iconAltTextAlignLeft: 'Izquierda',
    iconAltTextAlignRight: 'Derecha',
    iconAltTextClose: 'Cerrar',
    iconAltTextLineStyleDashed: 'Líneas largas',
    iconAltTextLineStyleDotted: 'Línea corta discontinua',
    iconAltTextLineStyleSolid: 'Sólido',
    iconAltTextPositionBottom: 'Inferior',
    iconAltTextPositionCenter: 'Centro',
    iconAltTextPositionTop: 'Parte superior',
    inputTextareaPlaceholder: 'Agregar texto',
    measurerDateRangeBars: '${value}[number] barras',
    measurerPriceRangePercent: '${value}[percent]',
    measurerPriceRangeValue: '${value}[number]',
    measurerVolume: 'Vol ${value}',
    overlayLoadingData: 'Cargando datos...',
    overlayNoData: 'No hay datos para mostrar',
    overlayNoVisibleSeries: 'No hay series visibles',
    overlayUnsupportedBrowser: 'Versión del navegador no compatible. Por favor, actualice su navegador.',
    seriesHistogramTooltipCount: '${yName} (cuenta)',
    seriesHistogramTooltipFrequency: 'Frecuencia',
    seriesHistogramTooltipMean: '${yName} (media)',
    seriesHistogramTooltipSum: '${yName} (suma)',
    toolbarAnnotationsArrow: 'Flecha',
    toolbarAnnotationsArrowDown: 'Flecha hacia abajo',
    toolbarAnnotationsArrowUp: 'Flecha Arriba',
    toolbarAnnotationsCallout: 'Anotación',
    toolbarAnnotationsClearAll: 'Borrar todo',
    toolbarAnnotationsComment: 'Comentario',
    toolbarAnnotationsDatePriceRange: 'Fecha y Precio',
    toolbarAnnotationsDateRange: 'Rango de fechas',
    toolbarAnnotationsDelete: 'Eliminar',
    toolbarAnnotationsDisjointChannel: 'Canal disjunto',
    toolbarAnnotationsDragHandle: 'Arrastrar barra de herramientas',
    toolbarAnnotationsFibonacciAnnotations: 'Fibonacci',
    toolbarAnnotationsFibonacciRetracement: 'Retroceso de Fib',
    toolbarAnnotationsFibonacciRetracementTrendBased: 'Tendencia basada en Fibonacci',
    toolbarAnnotationsFillColor: 'Color de Relleno',
    toolbarAnnotationsHorizontalLine: 'Línea horizontal',
    toolbarAnnotationsLineAnnotations: 'Líneas de tendencia',
    toolbarAnnotationsLineColor: 'Color de línea',
    toolbarAnnotationsLineStrokeWidth: 'Ancho del trazo de línea',
    toolbarAnnotationsLineStyle: 'Estilo de línea',
    toolbarAnnotationsLock: 'Bloquear',
    toolbarAnnotationsMeasurerAnnotations: 'Medidores',
    toolbarAnnotationsNote: 'Nota',
    toolbarAnnotationsParallelChannel: 'Canal Paralelo',
    toolbarAnnotationsPriceRange: 'Rango de precios',
    toolbarAnnotationsQuickDatePriceRange: 'Medir',
    toolbarAnnotationsSettings: 'Configuraciones',
    toolbarAnnotationsShapeAnnotations: 'Flechas',
    toolbarAnnotationsText: 'Texto',
    toolbarAnnotationsTextAnnotations: 'Anotaciones de texto',
    toolbarAnnotationsTextColor: 'Color del texto',
    toolbarAnnotationsTextSize: 'Tamaño del texto',
    toolbarAnnotationsTrendLine: 'Línea de tendencia',
    toolbarAnnotationsUnlock: 'Desbloquear',
    toolbarAnnotationsVerticalLine: 'Línea Vertical',
    toolbarRange1Month: '1M',
    toolbarRange1MonthAria: '1 mes',
    toolbarRange1Year: '1A',
    toolbarRange1YearAria: '1 año',
    toolbarRange3Months: '3M',
    toolbarRange3MonthsAria: '3 meses',
    toolbarRange6Months: '6M',
    toolbarRange6MonthsAria: '6 meses',
    toolbarRangeAll: 'Todo',
    toolbarRangeAllAria: 'Todo',
    toolbarRangeYearToDate: 'Año en curso',
    toolbarRangeYearToDateAria: 'Año hasta la fecha',
    toolbarSeriesTypeCandles: 'Velas',
    toolbarSeriesTypeDropdown: 'Tipo de Gráfico',
    toolbarSeriesTypeHighLow: 'Alto Bajo',
    toolbarSeriesTypeHLC: 'HLC',
    toolbarSeriesTypeHollowCandles: 'Velas Huecas',
    toolbarSeriesTypeLine: 'Línea',
    toolbarSeriesTypeLineWithMarkers: 'Línea con marcadores',
    toolbarSeriesTypeOHLC: 'OHLC',
    toolbarSeriesTypeStepLine: 'Línea escalonada',
    toolbarZoomPanEnd: 'Desplazar hasta el final',
    toolbarZoomPanLeft: 'Desplazar a la izquierda',
    toolbarZoomPanRight: 'Desplazar a la derecha',
    toolbarZoomPanStart: 'Mover al inicio',
    toolbarZoomReset: 'Restablecer el zoom',
    toolbarZoomZoomIn: 'Acercar',
    toolbarZoomZoomOut: 'Alejar',
    tooltipPaginationStatus: '${index}[number] de ${count}[number]',
};
